import { RibbonButton } from 'common/components';
import { UserAddOutlined } from '@ant-design/icons';
import Messages from 'i18n/messages/home';
import { useState } from 'react';

import AssignUserModal from 'pages/sso-approval/modal/AssignUserModal';

const AssignUserSsoApproval = ({ selectedItem, sectionDisabled }) => {
  const [visibleModal, setVisibleModal] = useState(false);

  const checkDisabled = () => {
    const status = selectedItem?.poolStatus;

    const statusDisabled = status && status?.toLowerCase() !== 'pending';

    return sectionDisabled || statusDisabled;
  };

  return (
    <>
      <RibbonButton
        icon={<UserAddOutlined />}
        label={Messages.assignUser}
        onClick={() => setVisibleModal(true)}
        disabled={checkDisabled()}
      />
      {visibleModal && (
        <AssignUserModal
          selectedItem={selectedItem}
          visibleModal={visibleModal}
          setVisibleModal={setVisibleModal}
        />
      )}
    </>
  );
};

export default AssignUserSsoApproval;
